import { render, staticRenderFns } from "./feature-card2.vue?vue&type=template&id=19e34be8&scoped=true"
import script from "./feature-card2.vue?vue&type=script&lang=js"
export * from "./feature-card2.vue?vue&type=script&lang=js"
import style0 from "./feature-card2.vue?vue&type=style&index=0&id=19e34be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e34be8",
  null
  
)

export default component.exports